import { createElementBlock as r, openBlock as t, createElementVNode as s, Fragment as l, renderList as n, normalizeClass as d, toDisplayString as c } from "vue";
const _ = {
  role: "rowgroup",
  class: "ds-table__row-group ds-table__header"
}, i = {
  role: "row",
  class: "ds-table__row",
  "data-j-row": ""
}, m = /* @__PURE__ */ Object.assign({
  name: "DsTableRowGroupHeader"
}, {
  __name: "table-row-group-header",
  props: {
    columns: { type: Array, required: !0 }
  },
  setup(a) {
    return (u, p) => (t(), r("div", _, [
      s("div", i, [
        (t(!0), r(l, null, n(a.columns, (e, o) => (t(), r("span", {
          key: e.key,
          role: "columnheader",
          "aria-sort": "none",
          class: d(["ds-table__col", [
            `ds-table__col--${e.cols}`,
            `ds-text-align-${e.align}`,
            { "ds-padding-left-0": o === 0 },
            { "ds-padding-right-0": o === a.columns.length - 1 }
          ]]),
          "data-j-column": ""
        }, c(e.text), 3))), 128))
      ])
    ]));
  }
});
export {
  m as default
};
